import { FeatureFlag } from '@ps/web-core-enums';

import useFeature from '@swf/core/hooks/useFeature';

import useRmfUKDefaultFlow from './UK/useRmfUKDefaultFlow';
import useRmfUKPhoneAfterAddressFlow from './UK/useRmfUKPhoneAfterAddressFlow';
import useRmfUKPhoneAfterNameFlow from './UK/useRmfUKPhoneAfterNameFlow';

const useRmfUKFlow = () => {
  const swcRmfUKPhoneAfterAddress = useFeature(FeatureFlag.SwcRmfUKPhoneAfterAddress);
  const swcRmfUKPhoneAfterName = useFeature(FeatureFlag.SwcRmfUKPhoneAfterName);

  if (swcRmfUKPhoneAfterName) {
    return useRmfUKPhoneAfterNameFlow();
  } else if (swcRmfUKPhoneAfterAddress) {
    return useRmfUKPhoneAfterAddressFlow();
  } else {
    return useRmfUKDefaultFlow();
  }
};

export default useRmfUKFlow;
